const ScoreGauge = ({ score, size = "small", band }) => {
  const isNA = score === "N/A";
  const radius = size === "small" ? 12 : 18;
  const strokeWidth = size === "small" ? 3 : 4;
  const fontSize = size === "small" ? "text-xs" : "text-sm";
  const circumference = 2 * Math.PI * radius;
  const svgSize = size === "small" ? 30 : 40;

  // Wrap the gauge with its qualitative band label (Poor/Weak/.../Excellent)
  // when one is supplied, so the band reads directly beneath the number.
  const withBand = (gauge) =>
    band ? (
      <div className="flex flex-col items-center gap-1">
        {gauge}
        <span className="text-[10px] font-medium text-on-surface-variant leading-none">{band}</span>
      </div>
    ) : (
      gauge
    );

  if (isNA) {
    return withBand(
      <div
        className="relative flex items-center justify-center"
        style={{ width: svgSize, height: svgSize }}
      >
        <svg width={svgSize} height={svgSize} className="transform -rotate-90 absolute">
          <circle
            className="text-surface-container-high"
            strokeWidth={strokeWidth}
            stroke="currentColor"
            fill="transparent"
            r={radius}
            cx={svgSize / 2}
            cy={svgSize / 2}
          />
        </svg>
        <span className="font-bold text-[10px] text-on-surface">{score}</span>
      </div>,
    );
  }

  const offset = circumference - (score / 100) * circumference;
  const color = score > 80 ? "#22c55e" : score > 50 ? "#f59e0b" : "#ef4444";
  return withBand(
    <div
      className="relative flex items-center justify-center"
      style={{ width: svgSize, height: svgSize }}
    >
      <svg width={svgSize} height={svgSize} className="transform -rotate-90 absolute">
        <circle
          className="text-surface-container-high"
          strokeWidth={strokeWidth}
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={svgSize / 2}
          cy={svgSize / 2}
        />
        <circle
          className="transition-all duration-700 ease-out"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          stroke={color}
          fill="transparent"
          r={radius}
          cx={svgSize / 2}
          cy={svgSize / 2}
        />
      </svg>
      <span className={`font-bold ${fontSize} text-on-surface`}>{score}</span>
    </div>,
  );
};

export default ScoreGauge;
